<ion-content class="menu-bg bg-gray-50 h-full">
  <ion-list class="px-2 pt-3" lines="none" style="background-color: transparent">
    <div *ngFor="let p of menus; let i = index">
      <ion-menu-toggle *ngIf="!p.children || (p.children && p.children.length == 0); else hasChildrenTemplate">
        <ion-item
          lines="none"
          (click)="goto(p.url)"
          [routerLink]="p.url"
          class="flex items-center rounded-md px-2 py-2 mb-1 bg-white hover:bg-blue-50 transition-colors"
          *ngIf="p.active"
          [routerLinkActive]="p.url ? 'border-l-4 border-blue-600 bg-blue-50' : ''"
          [routerLinkActiveOptions]="{ exact: true }"
          routerDirection="root"
          detail="false"
        >
          <ion-icon slot="start" [name]="p.icon" class="text-emerald-600 mr-2"></ion-icon>
          <ion-label class="text-sm font-medium text-gray-800">
            {{ p.title | translate }}
          </ion-label>
          <ion-badge *ngIf="p.title == 'Chat' && isNewMessage" color="red" class="ml-auto">New</ion-badge>
          <ion-badge *ngIf="p.title == 'Voice Comms' && hasNewVoice" color="red" class="ml-auto">New</ion-badge>
        </ion-item>
      </ion-menu-toggle>

      <ng-template #hasChildrenTemplate>
        <ion-item
          lines="none"
          (click)="p.expanded = !p.expanded"
          class="flex items-center rounded-md px-2 py-2 mb-1 bg-white cursor-pointer hover:bg-blue-50 transition-colors"
          *ngIf="p.children?.length > 0 && p.active"
          detail="false"
        >
          <ion-icon slot="start" [name]="p.icon" class="text-emerald-600 mr-2"></ion-icon>
          <ion-label class="text-sm font-medium text-gray-800">
            {{ p.title | translate }}
          </ion-label>
          <ion-icon slot="end" [name]="p.expanded ? 'chevron-up' : 'chevron-down'" class="text-gray-500 ml-auto"></ion-icon>
        </ion-item>

        <ion-list *ngIf="p.expanded" lines="none" class="ml-4 space-y-1">
          <ion-item *ngFor="let s of p.children" class="flex items-center px-2 py-2 rounded-md hover:bg-blue-50 transition-colors" (click)="goto(s.url)">
            <ion-icon slot="start" class="text-gray-400 mr-2"></ion-icon>
            <ion-label class="text-sm text-gray-700">{{ s.title | translate }}</ion-label>
          </ion-item>
        </ion-list>
      </ng-template>
    </div>

    <hr class="my-3 border-gray-300" />

    <!-- Live Stream -->
    <ion-menu-toggle autoHide="false" (click)="goLiveVideo()">
      <ion-item class="flex items-center px-2 py-2 rounded-md bg-white hover:bg-blue-50 transition-colors">
        <ion-icon slot="start" name="radio" class="text-emerald-600 mr-2"></ion-icon>
        <ion-label class="text-sm font-medium text-gray-800"> {{ "Live Stream" | translate }} </ion-label>
      </ion-item>
    </ion-menu-toggle>

    <!-- Log Out -->
    <ion-menu-toggle autoHide="false" (click)="onLogout()">
      <ion-item class="flex items-center px-2 py-2 rounded-md bg-white hover:bg-blue-50 transition-colors">
        <ion-icon slot="start" name="log-out" class="text-emerald-600 mr-2"></ion-icon>
        <ion-label class="text-sm font-medium text-gray-800"> {{ "Log Out" | translate }} </ion-label>
      </ion-item>
    </ion-menu-toggle>
  </ion-list>
</ion-content>
